import { Domain, } from '@repo/domain';
import { useQueryClient } from '@tanstack/react-query';
import { addressPredictionKeys, addressPredictionOptions } from '../../constants/addressPredictions';
import { resolveRepository } from '../../registry/resolveRepository';
export function useAddressPredictionActions() {
    const queryClient = useQueryClient();
    const getAddressPredictions = async (filter, scope) => {
        return await queryClient.fetchQuery(addressPredictionOptions.get(filter, scope));
    };
    const resetAddressPredictionSession = async () => {
        const repo = await resolveRepository(Domain.AddressPrediction);
        repo.resetSession();
        await queryClient.invalidateQueries({ queryKey: addressPredictionKeys.all });
    };
    return {
        getAddressPredictions,
        resetAddressPredictionSession,
    };
}
